const labelEnum = {
  commercialTruck: 'commercial_truck',
  mechanicalEquipment: 'mechanical_equipment',
  movable: 'movable',
  oversizedPassengerVehicle: 'oversized_passenger_vehicle',
  personalProperty: 'personal_property',
  // HIDING ALL DETECTIONS OF THIS TYPE FOR THE TIME BEING.
  // ASKED BY ANDREW ON JULY 30th 2022
  // recreationalOffroadVehicle: 'recreational_offroad_vehicle',
  regularPassengerVehicle: 'regular_passenger_vehicle',
  structure: 'structure',
  // When adding labels, the need to be in alphabetical order here as we don't sort them later.
  // These are always last
  falsePositive: 'false_positive',
  duplicate: 'duplicate',
  unknown: 'unknown',
  unidentifiedObject: 'unidentified_object',
  tileDrainage: 'tile_drainage',
  exposedPipe: 'exposed_pipes',
};

export default labelEnum;
